import { IconButton, Menu, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import { GridMoreVertIcon } from '@mui/x-data-grid';
import React, { useState } from 'react'

function IntegrationOptionsMenu({
    row,
    onClickManageConnection,
    onClickRemoveConnection,
}) {

    const [menuAnchor, setMenuAnchor] = useState(null)

    return (
        (<Box>
            <IconButton style={{ paddingTop: '9px' }} onClick={(e) => setMenuAnchor(e.currentTarget)}>
                <GridMoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={() => {
                    setMenuAnchor(null)
                }}
            >
                <MenuItem onClick={() => { onClickManageConnection(row); setMenuAnchor(null) }} data-gxid="manageConnectionMenuLink">
                    Manage Connection
                </MenuItem>
                <MenuItem onClick={() => { onClickRemoveConnection(row); setMenuAnchor(null) }} data-gxid="removeConnectionMenuLink">
                    Remove Connection
                </MenuItem>
            </Menu>
        </Box>)
    )
}

export default IntegrationOptionsMenu